(() => {
  'use strict';
  const gate = document.querySelector('[data-grand-age-gate]');
  if (!gate || gate.dataset.initialized === 'true') return;
  gate.dataset.initialized = 'true';
  const key = 'grand-age-approved-v2';
  const sessionKey = 'grand-age-approved-session-v2';
  const designMode = gate.dataset.designMode === 'true';
  const now = Date.now();
  let remembered = 0;
  try { remembered = Number(localStorage.getItem(key)) || 0; } catch {}
  let sessionApproved = false;
  try { sessionApproved = sessionStorage.getItem(sessionKey) === 'true'; } catch {}
  const approved = remembered > now || sessionApproved;
  const languageStep = gate.querySelector('[data-grand-age-language]');
  const ageContent = gate.querySelector('[data-grand-age-content]');
  const showLanguage = () => {
    if (languageStep) languageStep.hidden = false;
    if (ageContent) ageContent.hidden = true;
    requestAnimationFrame(() => gate.querySelector('[data-grand-gate-lang]')?.focus({ preventScroll: true }));
  };
  const showAge = language => {
    if (window.UnionLanguage?.set) window.UnionLanguage.set(language);
    else try { localStorage.setItem('union-language', language); } catch {}
    if (languageStep) languageStep.hidden = true;
    if (ageContent) ageContent.hidden = false;
    requestAnimationFrame(() => (gate.querySelector('.grand-age-select') || gate.querySelector('select'))?.focus({ preventScroll: true }));
  };
  const open = () => {
    document.documentElement.classList.add('grand-age-locked');
    if (typeof gate.showModal === 'function' && !gate.open) gate.showModal();
    else gate.setAttribute('open', '');
    showLanguage();
  };
  const close = () => {
    document.documentElement.classList.remove('grand-age-locked');
    if (typeof gate.close === 'function' && gate.open) gate.close();
    else gate.removeAttribute('open');
  };
  if (designMode) close();
  else if (!approved) open();
  else close();
  gate.addEventListener('cancel', event => event.preventDefault());
  gate.addEventListener('click', event => { if (event.target === gate) event.preventDefault(); });
  gate.querySelectorAll('[data-grand-gate-lang]').forEach(button => button.addEventListener('click', () => showAge(button.dataset.grandGateLang)));
  gate.querySelector('[data-grand-age-change-language]')?.addEventListener('click', showLanguage);
  gate.querySelector('[data-grand-age-form]')?.addEventListener('submit', event => {
    event.preventDefault();
    const form = event.currentTarget;
    const month = Number(form.elements.month.value);
    const day = Number(form.elements.day.value);
    const year = Number(form.elements.year.value);
    const error = gate.querySelector('[data-grand-age-error]');
    const born = new Date(year, month - 1, day);
    const valid = month && day && year && born.getFullYear() === year && born.getMonth() === month - 1 && born.getDate() === day;
    if (!valid) {
      error.textContent = window.UnionLanguage?.translate(gate.dataset.invalidDate || 'Please enter a valid date of birth.') || gate.dataset.invalidDate || 'Please enter a valid date of birth.';
      error.hidden = false; return;
    }
    const today = new Date();
    let age = today.getFullYear() - year;
    if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) age--;
    if (age < Number(gate.dataset.minAge || 21)) {
      error.textContent = window.UnionLanguage?.translate(gate.dataset.underage || 'You must be 21 or older to enter this website.') || gate.dataset.underage || 'You must be 21 or older to enter this website.';
      error.hidden = false; return;
    }
    error.hidden = true;
    try {
      if (form.elements.remember.checked) localStorage.setItem(key, String(Date.now() + Number(gate.dataset.rememberDays || 30) * 86400000));
      else sessionStorage.setItem(sessionKey, 'true');
    } catch {}
    close();
  });
  document.addEventListener('shopify:section:select', event => {
    if (!designMode) return;
    if (event.target.contains(gate)) open();
    else close();
  });
  document.addEventListener('shopify:section:deselect', event => {
    if (designMode && event.target.contains(gate)) close();
  });
})();
